import React,{Component} from 'react';
import {connect} from "react-redux";
import i18n from "../../i18n";
import { withTranslation } from 'react-i18next';
import {Accordion,AccordionItem} from '@react/react-spectrum/Accordion';
import Well from '@react/react-spectrum/Well';
import Heading from '@react/react-spectrum/Heading';
import Button from '@react/react-spectrum/Button';
import CheckmarkCircle from '@react/react-spectrum/Icon/CheckmarkCircle';
import Info from '@react/react-spectrum/Icon/Info';
import _ from 'lodash';

class Terms extends Component{
    constructor(props){
        super(props);
        this.eventLists = [];   
        this.selectedIndex = [];     
    }
    renderTemplateHeader(eventObj){
        return(
            <div style={{display:'Flex',alignItems:'center',width:'100%'}}>
                <span style={{color:'#337ab7', fontSize:'1.1em'}}> 
                    {this.eventLists.length === 1 ? 
                        <strong>{i18n.t('termsConditionHeading',{eventObj})}</strong> :
                        <strong>{i18n.t('termsConditionHeadingWithProductName',{eventObj})}</strong> 
                    }                    
                </span>
            </div>
        )
    }
    renderTermsAndCondition(termsCondition){
        const {tc} = termsCondition;
        return(
            <div style={{padding:'10px',margin: '0em 2em', background: '#fff', textAlign:'justify'}} dangerouslySetInnerHTML={{__html: tc[0].text}}>
            </div>
        )
    }
    renderEventList() {
        var uniqueEvents = [];
        this.props.eventList && _.forEach(this.props.eventList, (event) =>{
            let foundObj = _.filter(uniqueEvents, {templateName : event.templateName})[0];
            if(!foundObj){               
                uniqueEvents.push(event);               
            }
            else{
                foundObj.productName = event.productName + ", " + foundObj.productName;
            }
        })  
        this.eventLists = uniqueEvents;
        for(let i=0; i<this.eventLists.length; i++){
            this.selectedIndex.push(i);
        }
        return(
            <div className="terms-outer">
                { this.eventLists && this.eventLists.length ?
                    <div>
                        <div style={{background:'#f5f5f5'}}>
                            <Heading variant="subtitle1">
                            {i18n.t('termsConditionTitle')}
                            </Heading>
                            <Well style={{color:'#fff',background:'#1473e6',marginTop: "20px"}}>
                            <div style={{display:'flex',alignItems:'center'}}> <Info/> &nbsp; {i18n.t('termsConditionMessage')}</div>
                            </Well>
                        </div>
                        <div>
                            <Accordion
                                aria-label="Terms and Condition"
                                multiselectable
                                defaultSelectedIndex={this.selectedIndex}
                                >
                                    { this.eventLists && this.eventLists.length ? (this.eventLists.map((eventObj,index)=>(
                                        <AccordionItem
                                        disabled={false}
                                        header={this.renderTemplateHeader(eventObj)}
                                        key={index}>
                                            {this.renderTermsAndCondition(eventObj.tc)}
                                        </AccordionItem>
                                ))) : ''}
                            </Accordion>
                        </div>  
                        <div style={{textAlign:'center',marginTop:'1em'}}>
                            <Button
                            type="button"
                            element="button"
                            label={i18n.t('label.termsAcceptBtn')}
                            icon={<CheckmarkCircle />}
                            onClick={this.props.onClick}
                            variant="cta"/>
                         </div>   
                    </div> : ''}
            </div>
        )
    }
    render(){
        return(
            <div>
                {this.renderEventList()}
            </div>
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        eventList: state.UserInfoReducer.eventTermsCondition,
        allSelectedTNC: state.UserInfoReducer.allSelectedTNC,
    }
};



export default connect(mapStateToProps)(withTranslation()(Terms));
